// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"precise-monitor"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 12H12M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 20L8.5 15.5M12 7V3M8.5 8.5L4 4M15.5 8.5L20 4M17 12H21M20 20L15.5 15.5M12 21V17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PreciseMonitorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'precise-monitor',
    ref,
    icon: element,
  },
));

PreciseMonitorIcon.displayName = 'PreciseMonitorIcon';

export default PreciseMonitorIcon;
